import ReactGA from "react-ga4";

export const initAnalytics = () => {
  ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID);
};